import { render, staticRenderFns } from "./CleanTalkSettings.vue?vue&type=template&id=017130dc&"
import script from "./CleanTalkSettings.vue?vue&type=script&lang=js&"
export * from "./CleanTalkSettings.vue?vue&type=script&lang=js&"
import style0 from "./CleanTalkSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017130dc')) {
      api.createRecord('017130dc', component.options)
    } else {
      api.reload('017130dc', component.options)
    }
    module.hot.accept("./CleanTalkSettings.vue?vue&type=template&id=017130dc&", function () {
      api.rerender('017130dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/CleanTalkSettings.vue"
export default component.exports